<template>
  <div>

    <ViewTemplateConfiguration :templateList="templateList" :showSearch="false" :showHorizontalFilter="false"
      :propsParam="propsParam">

      <div slot="content-buttons">
        <Button _key="btnExpenseCreateUpdate" title="Despesa" classIcon="fas fa-plus-circle" type="primary" size="small"
          :clicked="create" />
      </div>
    </ViewTemplateConfiguration>

    <Modal title="Despesa" :width="850" :height="250" v-show="showModal('expenseCreateUpdate')">
      <ExpenseCreateUpdate :rent="rent" />
    </Modal>

  </div>
</template>

<script>

import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";

import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import ExpenseCreateUpdate from './ExpenseCreateUpdate.vue'

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ExpenseList",
  components: {
    ViewTemplateConfiguration, Alert, Button, Modal, ExpenseCreateUpdate
  },
  props: {
    rent: Object,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/rental/expense/get-all",
        urlDeleteAllApi: "/api/v1/rental/expense/delete",
        headerTable: [],
      },
      propsParam: {
        any: this.rent.id,
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["event", "showModal"]),
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "addEvent", "removeLoading"]),
    create() {
      this.addEvent({ name: "expenseCreateUpdate" });
      this.openModal('expenseCreateUpdate');
      this.removeLoading(["btnExpenseCreateUpdate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "expenseUpdate") this.openModal("expenseCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
<style>
.box-finance {
  width: 10px;
  height: 10px;
  border-radius: 20px;
  margin-right: 8px;
}

.finance-delay {
  background-color: red;
}

.finance-paid {
  background-color: #009183;
}

.finance-today {
  background-color: #ff8a1b;
}

.finance-scheduled {
  background-color: #3d4eae;
}
</style>